import { render, staticRenderFns } from "./companyInformation.vue?vue&type=template&id=1d5f5edc&scoped=true"
import script from "./companyInformation.vue?vue&type=script&lang=js"
export * from "./companyInformation.vue?vue&type=script&lang=js"
import style0 from "./companyInformation.vue?vue&type=style&index=0&id=1d5f5edc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5f5edc",
  null
  
)

export default component.exports